




import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KlaviyoFormEmbed',
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    form_id: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return {
      formId: props.form_id,
    };
  },
});
